import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { Box, Typography, Grid } from "@mui/material";

interface MultipleHealthChartsProps {
  healthData: any[];
  refreshTrigger: number;
}

const MultipleHealthCharts: React.FC<MultipleHealthChartsProps> = ({
  healthData,
  refreshTrigger,
}) => {
  // Helper function to format date
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
  };

  // Helper function to create a chart
  const createChart = (title: string, dataKeys: string[], colors: string[]) => (
    <Box sx={{ height: 300, mb: 4 }}>
      <Typography variant="h6" gutterBottom>
        {title}
      </Typography>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={healthData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="formatted_date" tickFormatter={formatDate} />
          <YAxis />
          <Tooltip labelFormatter={formatDate} />
          <Legend />
          {dataKeys.map((key, index) => (
            <Line
              key={key}
              type="monotone"
              dataKey={key}
              stroke={colors[index]}
              activeDot={{ r: 8 }}
            />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </Box>
  );

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        {createChart("Resting Heart Rate", ["rhr"], ["#ff0000"])}
      </Grid>
      <Grid item xs={12} md={6}>
        {createChart(
          "Blood Pressure",
          ["systolic", "diastolic"],
          ["#8884d8", "#82ca9d"]
        )}
      </Grid>
      <Grid item xs={12} md={6}>
        {createChart(
          "BMI vs. Waist Circumference",
          ["bmi", "wc"],
          ["#ffc658", "#ff7300"]
        )}
      </Grid>
      <Grid item xs={12} md={6}>
        {createChart(
          "Glucose and Triglycerides",
          ["fpg", "pt"],
          ["#8884d8", "#82ca9d"]
        )}
      </Grid>
      <Grid item xs={12} md={6}>
        {createChart(
          "Cholesterol",
          ["tc", "hdl", "ldl"],
          ["#8884d8", "#82ca9d", "#ffc658"]
        )}
      </Grid>
      <Grid item xs={12} md={6}>
        {createChart(
          "Risk Score",
          ["risk_score_calculation.risk_score"],
          ["#ff0000"]
        )}
      </Grid>
    </Grid>
  );
};

export default MultipleHealthCharts;
